import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Fleet from "./pages/Fleet";
import Industries from "./pages/Industries";
import Network from "./pages/Network";
import WhyUs from "./pages/WhyUs";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";
import { Privacy, Terms } from "./pages/Legal";
import Admin from "./pages/Admin";
import GoodsTransport from "./pages/GoodsTransport";
import PassengerTransport from "./pages/PassengerTransport";
import LiquidTransport from "./pages/LiquidTransport";
import InfrastructureTransport from "./pages/InfrastructureTransport";
import Gallery from "./pages/Gallery";
import UpcomingFleet from "./pages/UpcomingFleet";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/fleet" element={<Fleet />} />
            <Route path="/goods-transport" element={<GoodsTransport />} />
            <Route path="/liquid-transport" element={<LiquidTransport />} />
            <Route path="/infrastructure-transport" element={<InfrastructureTransport />} />
            <Route path="/passenger-transport" element={<PassengerTransport />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/upcoming-fleet" element={<UpcomingFleet />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/network" element={<Network />} />
            <Route path="/why-us" element={<WhyUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
